import RoutesBaseController from '../common/routes.base.controller'

class RoutesCreateController extends RoutesBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, RouteService, Modal, $translate, BranchService,SetupService, $scope,TruckService, LocationService, AppConstants) {

		super(Auth, $state, User, RouteService, Modal, $translate,TruckService)
		this.$scope = $scope
		this.TruckService = TruckService;
		this.SetupService = SetupService;
		this.LocationService = LocationService;
		this.AppConstants = AppConstants;
		this.defaultModel = {
			id: '',
			name: '',
			shortName: '',
			active: true,
			loadTruck: false,
			holdRoute: false,
			beginTime: '',
			branch: User.getUser().branchId,
			description: '',
			requireDriver: true,
			requireGuard: false,
			loggedInUser: User.getUser().id,
			specialFlag: false,
			uploadOnEndRouteOnly: true,
			autoOptimize: false,
			autoOpenATMs: false,
			bagoutFlag: false,
			requireLoadedAmount: false,
			requireResidualScan: false,
			requireBranchScan: false,
			requireThrow: true,
			eventRoute: false,
			shuttleRoute: false,
			liabilityLimit: null,
			autoCheckIn: false,
			autoCheckOut: false,
			checkOutByTanker: false,
			autoCheckInUpdate: false,
			autoThrowOnPack: false,
			NFCScan: false,
			NFCTagId: null,
			requireTruckScan: true,
			bagoutOnTruck: false,
			routeCutOff: false,
			routeCutOffTime: null,
			restrictToTruck: false,
			restrictTruck: null,
			optimizeAfterStop: false,
			autoSendPickupManifest: false,
			pickupManifestRecipientEmail: '',
			origination: 'BRANCH',
			routeMon: false,
			routeTue: false,
			routeWed: false,
			routeThu: false,
			routeFri: false,
			routeSat: false,
			routeSun: false,
			routeHol: false,
			sendRouteSheet: false,
			routeSheetRecipients: '',
			autoTransferAndClose: false,
			scanUserItems: false,
			maxRouteTime: null,
			maxMileage: null,
			estimatedRouteSpeed: null,
			lunch: false,
			lunchMinutes: '',
			lunchInTruck: false,
			break: false,
			breakMinutes: '',
			breakInTruck: false,
			rescheduleDeliveries: false,
			rescheduleHoldLocationId: null
		}

		this.weekdays = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon',
			day: 2
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue',
			day: 3
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed',
			day: 4
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu',
			day: 5
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri',
			day: 6
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat',
			day: 7
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun',
			day: 1
		}]

		this.day = {
			routeId: []
		}

		this.branch = []
		this.BranchService = BranchService;
		this.$translate = $translate;
		this.model = angular.copy(this.defaultModel);
		this.assignedTankers = {};
		this.contractDays = [];
		
		this.truckOptions = {
			options: [],
			totalRecords: 0
		};
		this.restrictTruckAddress = null;
		
		
		this.originationOptions = [
			{
				label: 'Branch',
				value: 'BRANCH'
			},
			{
				label: 'Truck',
				value: 'TRUCK'
			},
			{
				label: 'User',
				value: 'USER'
			}
		];

		this.routeDays = ["routeSun", "routeMon", "routeTue", "routeWed", "routeThu", "routeFri", "routeSat", "routeHol"];
		this.dayKeys = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Hol"];
		this.internalLocationsObj = {
			results: [],
			totalRecords: 0
		};
	}

	$onInit() {
		// this.loading = true;
		this.getAssignableTankersAtBranch('', 0);
		this.getAllTrucks();
		this.createRouteObjects();
		this.getSetupDetails(this.defaultModel.branch);
		this.loadInternalLocations();
	}

	getSetupDetails(branch) {
		this.SetupService.get(branch)
			.then((setup) => {
				this.model.branchTimezone = setup.timezone;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	reset() {
		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) { this.model[day.value].tankerId = null; }
		})
		this.assignedTankers = {};
		this.model = angular.copy(this.defaultModel);
		this.clearErrors();
	}

	ismeridian = true;
	toggleMode = function () {
		$scope.ismeridian = !$scope.ismeridian;
	};

	submit(evt) {
		if (this.loading) {
			return;
		}

		this.loading = true;
		this.upsertTankerAssignment();
		this.routeDays.forEach(route => this.model[route.value] = route.tick);

		this.Service.create({
			id: this.model.id,
			name: this.model.name,
			shortName: this.model.shortName,
			active: this.model.active,
			loadTruck: this.model.loadTruck,
			beginTime: this.model.beginTime ? moment(this.model.beginTime).format('HH:mm:ss') : null,
			branchId: this.model.branch,
			description: this.model.description,
			holdRoute: this.model.holdRoute,
			requireDriver: this.model.requireDriver,
			requireGuard: this.model.requireGuard,
			specialFlag: this.model.specialFlag,
			uploadOnEndRouteOnly: this.model.uploadOnEndRouteOnly,
			autoOptimize: this.model.autoOptimize,
			autoOpenATMs: this.model.autoOpenATMs,
			bagoutFlag: this.model.bagoutFlag,
			assignedTankers: this.assignedTankers,
			requireLoadedAmount: this.model.requireLoadedAmount,
			requireResidualScan: this.model.requireResidualScan,
			requireBranchScan: this.model.requireBranchScan,
			requireThrow: this.model.requireThrow,
			eventRoute: this.model.eventRoute,
			shuttleRoute: this.model.shuttleRoute,
			liabilityLimit: this.model.liabilityLimit || null,
			autoCheckIn: this.model.autoCheckIn,
			autoCheckOut: this.model.autoCheckOut,
			checkOutByTanker: this.model.checkOutByTanker,
			autoCheckInUpdate: this.model.autoCheckInUpdate,
			autoThrowOnPack: this.model.autoThrowOnPack,
			NFCScan: this.model.NFCScan,
			NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
			requireTruckScan: this.model.requireTruckScan,
			bagoutOnTruck: this.model.bagoutOnTruck,
			routeCutOff: this.model.routeCutOff,
			routeCutOffTime: this.model.routeCutOff && this.model.routeCutOffTime ? moment(this.model.routeCutOffTime).format('HH:mm:ss') : null,
			restrictToTruck: this.model.restrictToTruck,
			restrictTruckId: this.model.restrictToTruck && this.model.restrictTruck ? this.model.restrictTruck.id : null,
			optimizeAfterStop: this.model.optimizeAfterStop,
			autoSendPickupManifest: this.model.autoSendPickupManifest,
			pickupManifestRecipientEmail: this.model.pickupManifestRecipientEmail,
			origination: this.model.origination,
			routeMon: this.model.routeMon,
			routeTue: this.model.routeTue,
			routeWed: this.model.routeWed,
			routeThu: this.model.routeThu,
			routeFri: this.model.routeFri,
			routeSat: this.model.routeSat,
			routeSun: this.model.routeSun,
			routeHol: this.model.routeHol,
			sendRouteSheet: this.model.sendRouteSheet,
			routeSheetRecipients: this.model.sendRouteSheet ? this.model.routeSheetRecipients : null,
			timezone: this.model.branchTimezone,
			scanUserItems: this.model.scanUserItems,
			maxRouteTime: this.model.maxRouteTime ? moment(this.model.maxRouteTime).format('HH:mm:ss') : null,
			maxMileage: this.model.maxMileage,
			estimatedRouteSpeed: this.model.estimatedRouteSpeed,
			lunch: this.model.lunch,
			lunchMinutes: (this.model.lunch && this.model.lunchMinutes) ? moment(this.model.lunchMinutes).format('00:mm:ss') : null,
			lunchInTruck: this.model.lunch ? this.model.lunchInTruck : false,
			break: this.model.break,
			breakMinutes: (this.model.break && this.model.breakMinutes) ? moment(this.model.breakMinutes).format('00:mm:ss') : null,
			breakInTruck: this.model.break ? this.model.breakInTruck : false,
			rescheduleDeliveries: this.model.rescheduleDeliveries,
			autoTransferAndClose: this.model.autoTransferAndClose,
			rescheduleHoldLocationId: this.model.rescheduleDeliveries && this.model.rescheduleHoldLocationId ? this.model.rescheduleHoldLocationId.Value : null
		})
			.then((data) => {
				this.loading = false
                this.askCreate().then(() => this.createRouteObjects())
			})
			.catch((err) => {
				this.loading = false;
				const errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'ROUTE.NFCTagId') {
					this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
				}
				else if (err && err.data && err.data.message) {
					this.errorMessage += err.data.message + '<br/>'
				}
				else {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
			})
	}

	getAssignableTankersAtBranch(searchKey, offset) {
		this.dayArray = [], this.total = [];
		this.BranchService.getTankersAvailable(this.model.branch)
			.then((res) => {
				this.model.tankers = res;
				this.weekdays.forEach((d, index) => {
					if (offset == 0 || offset == undefined) {
						this.total.push({
							[d.value]: {
								total: res[d.day].length
							}
						});
						this.dayArray.push({
							[d.value]: this.mapRouteTankers(res[d.day], searchKey, d.day)
						})
					}
				})
			})
			.catch((err) => {
				console.log(err);
			})
	}

	mapRouteTankers(mapArray, searchKey, day) {
		return mapArray.map((obj) => {
			return {
				Key: obj.tankerId + ' | ' + obj.name,
				Value: obj.tankerId,
				Selected: obj.selected,
				dayOfWeek: day
			}
		});
	}

	sameForAll() {
		this.contractDays = [];

		this.weekdays.forEach((data) => {
			this.contractDays[data.value] = data;
		})

		if (this.model.sameForAll) {
			this.assignedTankers = {};
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					for (let key in this.model[day]) {
						this.model[day][key] = ''
					}
				}
			}
		}
	}

	updateAll(selectedDay, opt, weekday) {
		this.assignedTankers = {};
		if (this.model.sameForAll) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day] && this.model[selectedDay][opt]) {
						this.dayArray.filter((d) => {
							if (_.find(d[day], { Value: this.model[selectedDay][opt].Value })) {
								this.model[day].tankerId = this.model[selectedDay][opt]
							}
						})
					}
				}
			}
		}
		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) {
				this.model[day.value].tankerId.dayOfWeek = day.day;
				this.model[day.value].tankerId.Selected = 1;

				this.dayArray.filter((d) => {
					if (_.find(d[day.value], { Value: this.model[day.value].tankerId.Value })) {
						this.assignedTankers[this.model[day.value].tankerId.dayOfWeek] = this.model[day.value].tankerId.Value
					}
				})
			}
		})
	}

	assignTankers() {
		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) {
				this.assignedTankers[this.model[day.value].tankerId.dayOfWeek] = this.model[day.value].tankerId.Value
			}
		})
		// console.log(this.assignedTankers);
	}

	// (remove below two functions if you want new logic as per card #3451)
	upsertTankerAssignment() {
		if (this.model.requireThrow) this.assignTankers();
		else this.assignedTankers = {};
	}

	resetTankerAssignment() {
		this.weekdays.forEach((d, index) => {
			if (this.model[d.value]) this.model[d.value].tankerId = null;
		})
	}

	// (uncomment a below two functions if you want new logic as per card #3451)
	// upsertTankerAssignment() {
	// 	if (this.model.requireThrow || this.model.checkOutByTanker) this.assignTankers();
	// 	else this.assignedTankers = {};
	// }

	// resetTankerAssignment() {
	// 	if (!this.model.requireThrow && !this.model.checkOutByTanker) {
	// 		this.weekdays.forEach((d, index) => {
	// 			if (this.model[d.value]) this.model[d.value].tankerId = null;
	// 		})
	// 	}
	// }

	validateToggles() {
		this.model.autoThrowOnPack = this.model.requireThrow ? this.model.autoThrowOnPack : false;
	}
	getAllTrucks(){
		this.TruckService.getRestrictTrucks('', this.model.branch, null, 1000, 0)
		.then((data) => {
			this.truckOptions.totalRecords = data.total;
			this.truckOptions.options = this.mappingTruckData(data.results, '');
		})
	}

	mappingTruckData = (trucks, searchKey) => {
		let truckArray = [];
		trucks.map((truck) => {
		  truck.Key = truck.id + " | " + truck.make;
		  truck.Value = truck.id;
		  if (!searchKey) {
			if (this.model.restrictTruck) {
			  if (truck.id !== this.model.restrictTruck) {
				truckArray.push(truck);
			  }
			} else {
			  truckArray.push(truck);
			}
		  } else {
			truckArray.push(truck);
		  }
		});
		return truckArray;
	  }

	createRouteObjects() {
		this.routeDays = this.routeDays.map((route, index) => ({
			key: this.$translate.instant(`location.${this.dayKeys[index].toLowerCase()}`),
			value: route,
			tick: false,
		}));
	}

	isDaySelected(day) {
		day.tick = !day.tick;
	}

	loadInternalLocations(searchKey, offset) {
		searchKey = searchKey || '';

		const locationSearchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: '=',
					data: this.model.branch
				},
				{
					field: 'locationType',
					condition: '=',
					data: 'INTERNAL'
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			},
		}

		this.isLoadingInternalLocations = true;
		this.LocationService.getAllLocation(locationSearchObj, offset, this.AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.internalLocationsObj.totalRecords = data.total;
					this.internalLocationsObj.results = this.locMapping(data.results);
				} else {
					const locations = this.locMapping(data.results);
					this.internalLocationsObj.results = this.internalLocationsObj.results.concat(locations);
				}
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.isLoadingInternalLocations = false;
			})
	}

	locMapping(locations) {
		return locations.map((l) => {
			return {
				Key: l.id + " | " + l.name,
				Value: l.id
			}
		});
    }

	restrictToTruckChanged() {
		if (!this.model.restrictToTruck) {
			this.model.restrictTruck = null;
			this.restrictTruckAddress = null;
		} else {
			this.restrictTruckChanged();
		}
	}


	restrictTruckChanged() {
		this.restrictTruckAddress = null;
		let restrictTruck = this.model.restrictTruck;
		if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
			restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || 
						   _.find(this.truckOptions.options, { id: restrictTruck });
		}
		if (restrictTruck && restrictTruck.locationId) {
			this.LocationService.get(restrictTruck.locationId)
				.then((location) => {
					if (location.address || location.city || location.state || location.zip) {
						this.restrictTruckAddress = `${location.address || ''}, ${location.city || ''}, ${location.state || ''} ${location.zip || ''}`;
					} else {
						this.restrictTruckAddress = null;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}

}

export default RoutesCreateController;



// WEBPACK FOOTER //
// ./client/app/components/routes/create/routes.create.controller.js